import { createFileRoute } from "@tanstack/react-router";
import { LivePage } from "src/pages/Live/LivePage";

export const Route = createFileRoute("/")({
	component: LivePage,
});
